import { IStatus } from '@/shared/interfaces';
import { fetch } from '@/shared/fetch';
import { R } from '@/Resources.resx';

export const fetchIStatus = async <T, U>(
    url: string,
    method = 'GET',
    requestData?: U,
): Promise<T> => {
    let responseData: IStatus<T>;

    try {
        responseData = await fetch<IStatus<T>>(
            url,
            method,
            requestData,
            'application/json',
        );
    } catch (error) {
        // Handle error and throw a detailed message
        throw new Error(
            error instanceof Error ? error.message : R.UnknownError,
        );
    }

    // Check for errors in the response
    if (responseData?.HasErrors) {
        const errorMessage = responseData?.Errors.map((e) => e.Value).join(
            '\n',
        );
        throw new Error(errorMessage);
    }

    // Assuming response.Result contains some success information
    return responseData?.Result;
};
